<template>
    <form-row title="Attorney">
        <div class="-mt-3 sm:mt-0 sm:col-gap-1 flex-1">
            <input-text
                name="attorney_name"
                :value="attorney.attorney_name"
                label="Name"
                placeholder="Name"
                :read_only="read_only"
            />
        </div>

        <div class="mt-2 sm:mt-0 sm:col-gap-1 flex-1">
            <input-text
                name="attorney_email"
                :value="attorney.attorney_email"
                label="Email"
                placeholder="Email"
                :read_only="read_only"
            />
        </div>

        <div class="mt-2 sm:mt-0 sm:col-gap-1 flex-1">
            <input-text
                name="attorney_phone"
                :value="attorney.attorney_phone"
                label="Phone"
                placeholder="Phone"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },
}
</script>
